import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslations } from "@components/context/TranslationContext";

const ImageUpload = ({
    name,
    label,
    value,
    onChange,
    uploadButtonText,
    errors = [],
    className,
    accept = 'image/jpeg, image/jpg, image/png',
    onRemove,
    disabled = false,
    imageContain = true,
    ...rest
}) => {
    const { t } = useTranslations();
    const fileInputRef = useRef(null);
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (onChange) {
            onChange(file);
        } const url = URL.createObjectURL(file);
        setPreview(url);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleRemove = (e) => {
        e.preventDefault();
        onRemove?.();
        onChange?.(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    useEffect(() => {
        if (!preview) return undefined;
        // Revoke on cleanup (next change / unmount), not immediately — otherwise the blob
        // URL is freed before the preview's background-image can load it.
        return () => URL.revokeObjectURL(preview);
    }, [preview]);

    const photoBoxClassName = `settings-photo-box ${imageContain ? 'settings-photo-box-contain' : ''}`;
    const imageUrl = preview || value;
    const photoBoxStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};

    return (
        <div className="form-group">
            <label className="control-label alpaca-control-label" htmlFor={name}>
                {label}
            </label>
            <div className="settings-photo-box-container">
                <label
                    htmlFor={name}
                    className={photoBoxClassName}
                    style={photoBoxStyle}
                >
                    {imageUrl && (
                        <a
                            href="#"
                            className="close-icon"
                            onClick={handleRemove}
                        />
                    )}
                </label>
                <label htmlFor={name} className={classNames('btn btn-ghost', className, { disabled })}>
                    <span className="icon-svg-upload-01"></span>
                    {uploadButtonText || t('Upload logo')}
                </label>
                {errors.length > 0 && (
                    <ul className="errors">
                        {errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                )}
                <input
                    ref={fileInputRef}
                    type="file"
                    id={name}
                    name={name}
                    accept={accept}
                    onChange={handleFileChange}
                    disabled={disabled}
                    style={{ display: 'none' }}
                    {...rest}
                />
            </div>
        </div>
    );
};

ImageUpload.ACTION_KEEP = 'keep';
ImageUpload.ACTION_REPLACE = 'replace';
ImageUpload.ACTION_REMOVE = 'remove';

export default ImageUpload;
